import { TextButton } from '@zillow/constellation-10';

import { headerNavButtonStyles } from './styles';

type Props = {
  title?: string;
  onClick?: () => void;
  active?: boolean;
  children: React.ReactNode;
  path: string;
  escape?: boolean;
  useAbsolutePaths?: boolean;
  // Link component from react-router or next.js
  link?: React.ComponentType<React.PropsWithChildren<{ to: string }>>;
};

export const HeaderButton = ({
  title,
  onClick,
  active,
  children,
  path,
  escape = false,
  useAbsolutePaths,
  link: Link,
}: Props) => (
  <li>
    <TextButton
      title={title}
      asChild
      onClick={onClick}
      textStyle="body"
      tone="neutral"
      css={{
        ...headerNavButtonStyles,
        paddingRight: '800',
        ...(active && { color: 'text.accent.brand.hero', fontWeight: '600', textDecoration: 'none' }),
      }}
    >
      {!useAbsolutePaths && !escape && Link ? <Link to={path}>{children}</Link> : <a href={path}>{children}</a>}
    </TextButton>
  </li>
);
